export enum TipoMensajeModal {
    confirmacion,
    cancelacion,
    registraduria
}
